import React from 'react';
import PropTypes from 'prop-types';
import BaseSelectField from './baseSelect';

const AcSourceField = ({
  name,
  placeholder,
  width,
  onChange,
  value,
  options,
  popup
}) => {
  const popupTxt = `From what license pool will this AC draw? Your options depend on what set of licenses you purchased.`

  return (
    <BaseSelectField
      name={name}
      placeholder={placeholder}
      width={width}
      onChange={onChange}
      value={value}
      options={options}
      labelTxt="License"
      popupTxt={popup || popupTxt}
    />
  );
};

AcSourceField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  popup: PropTypes.string,
  value: PropTypes.string,
  width: PropTypes.number
}
export default AcSourceField



// WEBPACK FOOTER //
// ./webAdmin/forms/source.js